/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast. Keeping your custom
* Javascript in this file will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Thumbnail drag script removed because it was fighting with native mobile
  // scrolling and making the product gallery feel clunky/unreliable.

  document.addEventListener('DOMContentLoaded', () => {
    // no custom thumbnail drag
  });

  document.addEventListener('shopify:section:load', () => {
    // no custom thumbnail drag
  });

  // Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();